import request from "@/config/utils/request";
// import { addUrlPerFix } from "../utils";
// 附件预览 文件地址解密
export function getFileUrlSecret(data) {
  return request({
    url: "/apis/jrw/mdc/filePreview",
    // "/apis/jrw/oss/getFileUrlSecret",
    method: "post",
    data
  });
}
